var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 27.078 29.682",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gray_Divider"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.5259 0L0 29.1894L0.552109 29.682L27.078 0.492555L26.5259 0Z",
    fill: "var(--fill-0, #211414)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDivider);
export default __webpack_public_path__ + "static/media/gray_divider.d1e650c76e3485801cdde8688c47c8c8.svg";
export { ForwardRef as ReactComponent };